export enum SubscriptionType {
  gold = 'gold',
  plus = 'plus',
  free = 'free',
}
